import { render, staticRenderFns } from "./PolicyHolderManagement.vue?vue&type=template&id=2a6b7a1e&"
import script from "./PolicyHolderManagement.vue?vue&type=script&lang=js&"
export * from "./PolicyHolderManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports